var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafariPinnedTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.14, written by Peter Selinger 2001-2017\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2236 5104 c-347 -46 -718 -177 -1016 -358 -334 -204 -662 -535 -860 -868 -166 -279 -283 -604 -335 -928 -26 -160 -31 -521 -11 -690 44 -362 172 -731 360 -1040 204 -334 535 -662 868 -860 279 -166 604 -283 928 -335 160 -26 521 -31 690 -11 362 44 731 172 1040 360 334 204 662 535 860 868 166 279 283 604 335 928 26 160 31 521 11 690 -44 362 -172 731 -360 1040 -204 334 -535 662 -868 860 -279 166 -603 283 -928 335 -146 24 -565 29 -714 9z m-323 -2171 c3 -730 5 -850 20 -929 54 -292 165 -436 382 -496 107 -29 365 -32 465 -5 251 68 361 216 411 552 8 54 13 346 16 898 l5 817 274 0 274 0 0 -788 c0 -483 -4 -831 -11 -898 -59 -606 -332 -964 -826 -1080 -89 -21 -142 -27 -300 -31 -292 -8 -470 22 -659 111 -114 54 -167 90 -254 172 -159 150 -265 366 -322 654 -22 113 -22 129 -26 988 l-3 872 275 0 275 0 4 -837z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafariPinnedTab);
export default __webpack_public_path__ + "static/media/safari-pinned-tab.9e81c63aa9513848a1e33e384f587426.svg";
export { ForwardRef as ReactComponent };